import React from 'react'
import { Line } from 'react-chartjs-2'
import { Chart as ChartJS, Title, Tooltip, Legend } from 'chart.js'

const canvasBackgroundWhiteColorPlugin = {
  id: 'canvas_background_white_color_plugin',
  beforeDraw(chart: any): void {
    const ctx = chart.canvas.getContext('2d')
    ctx.save()
    ctx.globalCompositeOperation = 'destination-over'
    ctx.fillStyle = 'white'
    ctx.fillRect(0, 0, chart.width, chart.height)
    ctx.restore()
  }
}

interface IProps {
  data: any // TODO: corrigir tipagem
  options: any // TODO: corrigir tipagem
}

const PropertiesComparativeChart = React.forwardRef<ChartJS<'line', number[], string> | undefined, IProps>(
  (props: IProps, ref) => {
    const { data, options } = props

    return (
      <Line
        data-testid="properties-comparative-chart"
        data={data}
        options={options}
        ref={ref}
        plugins={[Title, Tooltip, Legend, canvasBackgroundWhiteColorPlugin]}
      />
    )
  }
)

PropertiesComparativeChart.displayName = 'PropertiesComparativeChart'

export { PropertiesComparativeChart }
